import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store/store'
import './registerServiceWorker'
import axios from 'axios'
import Notifications from 'vue-notification'
import './assets/main.scss'
import { prettifyErrorMessage } from './utils'

import 'flatpickr/dist/flatpickr.css'
import VueflatPickr from 'vue-flatpickr-component'

import moment from 'moment'
import 'moment/locale/id'

import numeral from 'numeral'

Vue.use(VueflatPickr)
Vue.use(Notifications)
Vue.config.productionTip = false
Vue.prototype.moment = moment
Vue.prototype.numeral = numeral

axios.interceptors.response.use(null, function(e) {
  if (!e.response) {
    Vue.notify({
      group: 'appNotif',
      title: 'Connection error',
      text: 'Please check your internet connection!',
      type: 'error'
    })

    return Promise.reject(e);
  }

  if (e.response.status === 403) {
    Vue.notify({
      group: 'appNotif',
      title: 'Authentication Error',
      text: 'Please relogin your current user connection!',
      type: 'error'
    })
  }

  if (e.response.status >= 400 && e.response.status < 500 && e.response.status !== 403) {
    Vue.notify({
      group: 'appNotif',
      title: 'Fail',
      text: prettifyErrorMessage(e.response.data.message),
      type: 'warn'
    }) 
  }

  if (e.response.status >= 500 && e.response.status < 600) {
    Vue.notify({
      group: 'appNotif',
      title: 'Internal Server Error',
      text: e.response.data.message,
      type: 'error'
    }) 
  }

  return Promise.reject(e);
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
